import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { FormResetButton, FormTextField } from '../../../../components/Form';
import { AuctionFilter } from '../../../../components/Filters';
import { Form, Field, FormSpy } from 'react-final-form';
import { useGetSalesHistoryQuery } from 'services/api/sales';
import { setFilters, resetFilters, selectTabFilters } from 'services/salesHistorySlice/salesHistorySlice';
import { debounce } from 'utils';
import { useScreen } from 'usehooks-ts';

const StyledFilterWrapper = styled.div`
  display: flex;
  margin-top: 8px;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 1180px) {
    flex-direction: column;
    > div > div {
      width: 100%;
    }
  }
  > div > div {
    min-width: 160px;
  }
`;

const StyledFieldWrapper = styled.div`
  && {
    display: flex;
    align-items: flex-end;
    > div:not(:last-child) {
      margin-right: 15px;
    }
    button {
      margin: 0 0 5px 5px;
    }
    @media (max-width: 1180px) {
      && {
        flex-direction: column;
        width: 100%;
        > div {
          margin-right: 0;
          margin-top: 10px;
        }
        button {
          margin-top: 10px;
        }
      }
    }
  }
`;

const toUpperCase = value => value && value.toUpperCase();

const scrollActivePanel = tabPanelsRef => {
  if (!tabPanelsRef?.current) return;
  const activePanel = tabPanelsRef.current.querySelector('[data-tab-panel="active"]');
  activePanel?.scrollTo(0, 0);
};

const shallowEqual = (a, b) => {
  console.log(a === b, 'a === b');
  if (a === b) return true;
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every(k => a[k] === b[k]);
};

const Filter = ({ tabPanelsRef }) => {
  const onSubmit = () => {};
  const dispatch = useDispatch();

  const { pages, perPage, tab } = useSelector(state => state.salesHistory);
  const filters = useSelector(state => selectTabFilters(state, tab));
  const page = pages[tab] || 1;
  const { data } = useGetSalesHistoryQuery({
    limit: perPage,
    offset: page,
    ...filters
  });

  const makes = data?.makes || [];
  const models = data?.models || [];

  const lastDispatchedRef = useRef(filters);
  lastDispatchedRef.current = filters;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChange = useCallback(
    debounce(({ values }) => {
      console.log(
        values,
        lastDispatchedRef.current,
        shallowEqual(values, lastDispatchedRef.current),
        'values + ref + equal'
      );
      if (shallowEqual(values, lastDispatchedRef.current)) return;
      dispatch(setFilters(values));
      scrollActivePanel(tabPanelsRef);
    }, 500),
    [tab]
  );

  const { width = 0 } = useScreen();
  const isMobile = width < 567;

  return (
    <StyledFilterWrapper>
      {!isMobile && (
        <Form key={tab} onSubmit={onSubmit} initialValues={filters}>
          {() => (
            <StyledFieldWrapper>
              <Field component={FormTextField} name="keyword" label="Keyword" />
              <Field component={FormTextField} name="vin" label="VIN Search" normalize={toUpperCase} />
              <Field component={FormTextField} name="make" label="Filter by Make" select>
                <MenuItem value="">All</MenuItem>
                {makes.map((make, index) => (
                  <MenuItem key={index} value={make}>
                    {make}
                  </MenuItem>
                ))}
              </Field>
              {models.length !== 0 && (
                <Field component={FormTextField} name="model" label="Filter by Model" select>
                  <MenuItem value="">All</MenuItem>
                  {models.map((model, index) => (
                    <MenuItem key={index} value={model}>
                      {model}
                    </MenuItem>
                  ))}
                </Field>
              )}
              {tab === 'all' && (
                <Field component={FormTextField} name="status" label="Filter by Bid Status" select>
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="undecided">Undecided</MenuItem>
                  <MenuItem value="pulled">Pulled</MenuItem>
                  <MenuItem value="countered">Countered</MenuItem>
                  <MenuItem value="processing">Processing</MenuItem>
                  <MenuItem value="awarded">Awarded</MenuItem>
                </Field>
              )}
              <AuctionFilter formType="final-form" />
              {(tab === 'all' || tab === 'sold') && (
                <Field component={FormTextField} name="title_status" label="Filter by Title Status" select>
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="waiting_on_title">Waiting On Title</MenuItem>
                  <MenuItem value="title_received">Title Received</MenuItem>
                  <MenuItem value="title_issues">Title Issues</MenuItem>
                </Field>
              )}
              <FormResetButton
                onClick={() => {
                  dispatch(resetFilters());
                  scrollActivePanel(tabPanelsRef);
                }}
              />
              <FormSpy subscription={{ values: true }} onChange={handleChange} />
            </StyledFieldWrapper>
          )}
        </Form>
      )}
    </StyledFilterWrapper>
  );
};

export default Filter;
